import { faCoffee } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding: 40px;
  }
`;

interface Props {
  onClick: () => void;
}
export const PersonalTasksEmptyState: FC<Props> = ({ onClick }) => (
  <EmptyStateContainer>
    <EmptyState
      image={<EmptyStateIcon icon={faCoffee} />}
      title={<FormattedMessage id="personal_tasks.empty.title" />}
      message={<FormattedMessage id="personal_tasks.empty.message" />}
      secondaryCTA={
        <EmptyState.CallToAction.Secondary onClick={onClick}>
          <FormattedMessage id="personal_tasks.empty.primary" />
        </EmptyState.CallToAction.Secondary>
      }
    />
  </EmptyStateContainer>
);
